import Button from '@mui/material/Button'
import { v4 as uuidv4 } from 'uuid'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateTopHeader,
  uplodateLoading
} from '../../../redux/features/common/commonSlice'
import { ProfileAbuseTable } from './ProfileAbuseTable'
import { VideoAbuseTable } from './VideoAbuseTable'
import { AbuseReportsList } from './AbuseReportsList'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast } from '../../constants/toaster'
import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
  InputAdornment,
  Pagination
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import PersonIcon from '@mui/icons-material/Person'
import VideocamIcon from '@mui/icons-material/Videocam'
import FlagIcon from '@mui/icons-material/Flag'
import { isEmpty } from 'lodash'
import { formatIndianNumber } from '../../lib/formatIndianNumber'

const REPORT_TYPES = {
  PROFILE: { label: 'Profile reports', tabLabel: 'Profile', icon: PersonIcon, color: '#5e72e4' },
  VIDEO: { label: 'Video reports', tabLabel: 'Video', icon: VideocamIcon, color: '#fb6340' }
}

export const ReportAbuseList = () => {
  const dispatch = useDispatch()
  const userData = useSelector((state) => state?.userData)
  const userPermisiions = useSelector((state) => state?.permission)

  const [callAPi, setCallAPi] = useState('')
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  })
  const [reportType, setReportType] = useState('PROFILE')
  const [sort_type] = useState('createdAt')
  const [sort_order] = useState(false)
  const [showAbuseReportDetails, setShowAbuseReportDetails] = useState({})
  const [searchText, setSearchText] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [datalist, setDatalist] = useState([])
  const [page, setPage] = useState(1)

  let viewPermission = true
  let editPermission = true
  let deletePermissionVal = true
  let activePermission = true

  if (userPermisiions?.modules?.length > 0) {
    const currentModulePermission = userPermisiions.modules.find(
      (element) => element.moduleId === '7'
    )?.permissions
    if (currentModulePermission) {
      viewPermission = currentModulePermission.find((e) => e.name === 'VIEW')?.isEnable ?? true
      editPermission = currentModulePermission.find((e) => e.name === 'EDIT')?.isEnable ?? true
      deletePermissionVal = currentModulePermission.find((e) => e.name === 'DELETE')?.isEnable ?? true
      activePermission = currentModulePermission.find((e) => e.name === 'ACTIVE')?.isEnable ?? true
    }
  }

  const typeMeta = REPORT_TYPES[reportType]

  const pageReportTotal = useMemo(
    () => datalist.reduce((sum, row) => sum + (Number(row?.reportCount) || 0), 0),
    [datalist]
  )

  useEffect(() => {
    dispatch(updateTopHeader('Report Abuse Manager'))
  }, [dispatch])

  useEffect(() => {
    if (viewPermission) {
      getReportAbuseList()
    }
  }, [callAPi])

  const handleChange = (event, value) => {
    setPage(value)
    setPagerecord((prev) => ({
      ...prev,
      pageNumber: value,
      pageSize: 10
    }))
    setCallAPi(uuidv4())
  }

  const handleTabChange = (_, newType) => {
    setReportType(newType)
    setPage(1)
    setPagerecord((prev) => ({ ...prev, pageNumber: 1 }))
    setCallAPi(uuidv4())
  }

  const handleFilterClick = useCallback(() => {
    setPage(1)
    setPagerecord((prev) => ({ ...prev, pageNumber: 1 }))
    setCallAPi(uuidv4())
  }, [])

  const handleResetFilter = () => {
    setStartDate(null)
    setEndDate(null)
    setSearchText('')
    setPage(1)
    setPagerecord((prev) => ({ ...prev, pageNumber: 1 }))
    setCallAPi(uuidv4())
  }

  const getReportAbuseList = async () => {
    let startDateObject
    let endDateObject
    if (startDate?.toDate()) {
      const newDate = new Date(startDate.toDate())
      newDate.setDate(newDate.getDate() + 1)
      startDateObject = newDate
    }
    if (endDate?.toDate()) {
      const newDate = new Date(endDate.toDate())
      newDate.setDate(newDate.getDate() + 2)
      endDateObject = newDate
    }
    try {
      const postJson = {
        userName: searchText?.trim(),
        page: pagerecord?.pageNumber - 1 || 0,
        limit: pagerecord.pageSize || 10,
        sort: sort_type,
        order: sort_order,
        type: reportType,
        startDate: startDateObject ?? '',
        endDate: endDateObject ?? ''
      }
      const res = await ApiCaller.post(postJson, urls.reportAbuseList, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        setDatalist(response?.data?.items || [])
        setPagerecord({
          totalItems: response?.data?.totalItems || 0,
          totalPages: response?.data?.totalPages || 1,
          pageNumber: pagerecord?.pageNumber,
          pageSize: 10
        })
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    }
  }

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8' />
          </div>
        </div>

        <div className='container-fluid mt--7'>
          <Card sx={{ borderRadius: 2, boxShadow: '0 0 2rem 0 rgba(136,152,170,.15)', mb: 3 }}>
            <CardContent sx={{ pb: 0 }}>
              <Box
                display='flex'
                flexWrap='wrap'
                justifyContent='space-between'
                alignItems='flex-start'
                gap={2}
                mb={2}
              >
                <Box>
                  <Typography variant='h5' fontWeight={700}>
                    Report Abuse Manager
                  </Typography>
                  <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5 }}>
                    Review and moderate reported user profiles and videos
                  </Typography>
                </Box>
                <Chip
                  icon={<FlagIcon />}
                  label={typeMeta.label}
                  sx={{ fontWeight: 600, bgcolor: `${typeMeta.color}18`, color: typeMeta.color }}
                />
              </Box>

              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={6} md={3}>
                  <Card variant='outlined' sx={{ borderRadius: 2, height: '100%' }}>
                    <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                      <Typography variant='caption' color='text.secondary' fontWeight={600}>
                        Reported items (page)
                      </Typography>
                      <Typography variant='h5' fontWeight={700}>
                        {formatIndianNumber(datalist.length, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Card variant='outlined' sx={{ borderRadius: 2, height: '100%' }}>
                    <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                      <Typography variant='caption' color='text.secondary' fontWeight={600}>
                        Total reports (page)
                      </Typography>
                      <Typography variant='h5' fontWeight={700}>
                        {formatIndianNumber(pageReportTotal, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Card variant='outlined' sx={{ borderRadius: 2, height: '100%' }}>
                    <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                      <Typography variant='caption' color='text.secondary' fontWeight={600}>
                        All records
                      </Typography>
                      <Typography variant='h5' fontWeight={700}>
                        {formatIndianNumber(pagerecord.totalItems, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Card variant='outlined' sx={{ borderRadius: 2, height: '100%' }}>
                    <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                      <Typography variant='caption' color='text.secondary' fontWeight={600}>
                        Viewing
                      </Typography>
                      <Box display='flex' alignItems='center' gap={1} mt={0.5}>
                        <typeMeta.icon sx={{ color: typeMeta.color, fontSize: 22 }} />
                        <Typography variant='h6' fontWeight={700}>
                          {typeMeta.tabLabel}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              <Tabs
                value={reportType}
                onChange={handleTabChange}
                sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
              >
                <Tab
                  value='PROFILE'
                  icon={<PersonIcon />}
                  iconPosition='start'
                  label='Profile reports'
                />
                <Tab
                  value='VIDEO'
                  icon={<VideocamIcon />}
                  iconPosition='start'
                  label='Video reports'
                />
              </Tabs>
            </CardContent>
          </Card>

          <Card sx={{ borderRadius: 2, boxShadow: '0 0 2rem 0 rgba(136,152,170,.15)' }}>
            <CardContent>
              <Grid container spacing={2} alignItems='center' sx={{ mb: 2 }}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size='small'
                    placeholder='Search by user name or user ID'
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleFilterClick()}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <SearchIcon fontSize='small' />
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker']} sx={{ pt: 0 }}>
                      <DatePicker
                        disableFuture
                        label='From date'
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        maxDate={endDate}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      />
                      <DatePicker
                        disableFuture
                        label='To date'
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        minDate={startDate}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Box display='flex' gap={1} flexWrap='wrap'>
                    <Button variant='contained' className='custom-filter-btn' onClick={handleFilterClick}>
                      Filter
                    </Button>
                    <Button variant='outlined' className='custom-filter-btn' onClick={handleResetFilter}>
                      Reset
                    </Button>
                  </Box>
                </Grid>
              </Grid>

              {reportType === 'PROFILE' ? (
                <ProfileAbuseTable
                  setShowAbuseReportDetails={setShowAbuseReportDetails}
                  datalist={datalist}
                  setCallAPi={setCallAPi}
                  pagerecord={pagerecord}
                  viewPermission={viewPermission}
                  editPermission={editPermission}
                  activePermission={activePermission}
                  deletePermissionVal={deletePermissionVal}
                />
              ) : (
                <VideoAbuseTable
                  datalist={datalist}
                  setCallAPi={setCallAPi}
                  setShowAbuseReportDetails={setShowAbuseReportDetails}
                  pagerecord={pagerecord}
                  viewPermission={viewPermission}
                  editPermission={editPermission}
                  activePermission={activePermission}
                  deletePermissionVal={deletePermissionVal}
                />
              )}

              {datalist?.length > 0 && (
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='center'
                  flexWrap='wrap'
                  gap={2}
                  mt={3}
                  pt={2}
                  borderTop={1}
                  borderColor='divider'
                >
                  <Typography variant='body2' color='text.secondary'>
                    Total records: {formatIndianNumber(pagerecord.totalItems, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })}
                  </Typography>
                  <Box display='flex' justifyContent='flex-end' alignItems='center' gap={2}>
                    <Pagination
                      className='custom-pagination-class'
                      count={pagerecord?.totalPages}
                      page={page}
                      onChange={handleChange}
                      color='secondary'
                      size='small'
                    />
                  </Box>
                </Box>
              )}
            </CardContent>
          </Card>

          {!isEmpty(showAbuseReportDetails) && (
            <AbuseReportsList
              show={showAbuseReportDetails}
              reportType={reportType}
              onHide={() => setShowAbuseReportDetails({})}
            />
          )}
        </div>
      </div>
    </>
  )
}
